/**
 * Finance UI helpers — shared by every FinanceEngine sub-component.
 */
import { TrendingDown, TrendingUp, AlertTriangle, AlertCircle, Info } from 'lucide-react';

export const REPORTING_CURRENCIES = ['QAR', 'USD', 'EUR', 'AED', 'SAR', 'GBP', 'JPY', 'CNY', 'INR'];

export const CADENCES = [
  { key: 'weekly',    label: 'Weekly',    sub: 'Last 7 days' },
  { key: 'monthly',   label: 'Monthly',   sub: 'Last calendar month' },
  { key: 'quarterly', label: 'Quarterly', sub: 'Last Q1/Q2/Q3/Q4' },
  { key: 'annual',    label: 'Annual',    sub: 'Last fiscal year' },
];

export const STATUS_META = {
  green:    { label: 'Healthy',   accent: '#10B981', bg: '#ECFDF5', text: '#065F46', icon: TrendingUp },
  amber:    { label: 'Watch',     accent: '#F59E0B', bg: '#FFFBEB', text: '#92400E', icon: AlertTriangle },
  red:      { label: 'Critical',  accent: '#EF4444', bg: '#FEF2F2', text: '#991B1B', icon: AlertCircle },
  infinite: { label: 'Profitable', accent: '#8B5CF6', bg: '#F5F3FF', text: '#5B21B6', icon: TrendingUp },
  unknown:  { label: 'No data',   accent: '#94A3B8', bg: '#F1F5F9', text: '#475569', icon: Info },
};

export const SEVERITY_META = {
  critical: { accent: '#EF4444', bg: '#FEF2F2', text: '#991B1B', icon: AlertCircle, label: 'Critical' },
  warning:  { accent: '#F59E0B', bg: '#FFFBEB', text: '#92400E', icon: AlertTriangle, label: 'Warning' },
  info:     { accent: '#3B82F6', bg: '#EFF6FF', text: '#1E40AF', icon: Info, label: 'Info' },
};

export function fmtCurrency(n, currency = 'QAR') {
  if (n === null || n === undefined) return '—';
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `${currency} ${Number(n).toLocaleString()}`;
  }
}

export function fmtMonths(m) {
  if (m === null || m === undefined) return '∞';
  if (m === 0) return '0 mo';
  return `${m.toFixed(1)} mo`;
}
